import {style} from "typestyle";

export const callToAction = style({
    lineHeight: "1.5em",
    height: "1.5em",
});
